const EducationExperienceGraduateType = {
  Unknown: "UNKNOWN",
  PlanToGraduate: "PLAN_TO_GRADUATE",
  Attending: "ATTENDING",
  Absence: "ABSENCE",
  Graduated: "GRADUATED",
  DropOut: "DROP_OUT",
  Candidate: "CANDIDATE"
};

export { EducationExperienceGraduateType };
//# sourceMappingURL=education-experience-graduate-type.mjs.map
